// Helper function to convert hex color to ARGB format
export const hexToArgb = (hex: string | undefined): string => {
	if (!hex) return 'FFFFFFFF'; // Default to white if no hex is provided
	// Remove # if present
	const cleanHex = hex.replace('#', '');
	// Add full opacity (FF) prefix to hex color
	return `FF${cleanHex.toUpperCase()}`;
};
